import React from "react";
import { Avatar } from "antd";
import styled from "styled-components";
import get from "lodash/get";

const CustomAvatar = styled(Avatar)`
  &[data-highlighted="true"] {
    box-shadow: 0px 0px 0px 2px var(--primary-color);
  }
`;

function UserAvatar(props) {
  const { currentUser, size, highlighted } = props;
  return (
    <React.Fragment>
      {currentUser.avatar && <CustomAvatar data-highlighted={highlighted} size={size} src={currentUser.avatar} />}
      {!currentUser.avatar && (
        <CustomAvatar data-highlighted={highlighted} size={size}>
          {get(currentUser.firstName, "[0]", "")}
          {get(currentUser.lastName, "[0]", "")}
        </CustomAvatar>
      )}
    </React.Fragment>
  );
}

export default UserAvatar;
